"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { StepperForm } from "@/components/organisms/StepperForm/StepperForm";
import { useNewRoomListing } from "./useNewRoomListing";
import { EmailVerificationBanner } from "@/components/molecules/EmailVerificationBanner";
import { NewRoomListingContextProvider } from "./NewRoomListingContext";
import NotificationMessage from "@/components/atoms/notifications/NotificationMessage";
import { useListingsLimit } from "../hooks/useListingsLimit";
import { ROUTE_PATHS } from "@/constants/routes";
import type { BusinessUnitsSchemaType, GetRealEstateManagementSchemaType } from "@/components/modules/portfolio/api/schemas/schemas";
type Props = {
  onClose?: () => void;
  onSubmitSuccess?: (listingId?: string, status?: string) => void;
  defaultListingType?: string;
  adminTargetUserId?: string;
  duplicateFromId?: string;
  prefillAssociation?: {
    unit: BusinessUnitsSchemaType;
    portfolio: GetRealEstateManagementSchemaType;
  };
  desktopHeightClassName?: string;
};
export function NewRoomListing(t0) {
  const $ = _c(57);
  const {
    onClose,
    onSubmitSuccess,
    defaultListingType,
    adminTargetUserId,
    duplicateFromId,
    prefillAssociation,
    desktopHeightClassName
  } = t0;
  const router = useRouter();
  const {
    isListingsMaxed,
    isLoading
  } = useListingsLimit();
  let t1;
  if ($[0] !== adminTargetUserId || $[1] !== defaultListingType || $[2] !== duplicateFromId || $[3] !== onSubmitSuccess || $[4] !== prefillAssociation) {
    t1 = {
      onSubmitSuccess,
      defaultListingType,
      adminTargetUserId,
      duplicateFromId,
      prefillAssociation
    };
    $[0] = adminTargetUserId;
    $[1] = defaultListingType;
    $[2] = duplicateFromId;
    $[3] = onSubmitSuccess;
    $[4] = prefillAssociation;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    tRoomListing,
    steps,
    isSubmitting,
    form,
    handleOnSubmit,
    session,
    isEmailVerified
  } = useNewRoomListing(t1);
  let t2;
  if ($[6] !== adminTargetUserId || $[7] !== isListingsMaxed || $[8] !== isLoading || $[9] !== router || $[10] !== tRoomListing) {
    t2 = !adminTargetUserId && !isLoading && isListingsMaxed ? <NotificationMessage variant="warning" hasCloseButton={false} title={tRoomListing("maxTitle")} description={tRoomListing("maxDescription")} action={{
      label: tRoomListing("seePlans"),
      onClick: () => router.push(`${ROUTE_PATHS.SUBSCRIPTIONS}?from=listings`),
      variant: "simple"
    }} /> : null;
    $[6] = adminTargetUserId;
    $[7] = isListingsMaxed;
    $[8] = isLoading;
    $[9] = router;
    $[10] = tRoomListing;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const maxedBanner = t2;
  let t3;
  if ($[12] !== tRoomListing) {
    t3 = tRoomListing("submitButtonText");
    $[12] = tRoomListing;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== tRoomListing) {
    t4 = tRoomListing("submitButtonDescription");
    $[14] = tRoomListing;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== tRoomListing) {
    t5 = tRoomListing("statusCardLabel");
    $[16] = tRoomListing;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== tRoomListing) {
    t6 = tRoomListing("statusSheetTitle");
    $[18] = tRoomListing;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== tRoomListing) {
    t7 = tRoomListing("saveAsDraft");
    $[20] = tRoomListing;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== tRoomListing) {
    t8 = tRoomListing("saveAsDraftDescription");
    $[22] = tRoomListing;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t7 || $[25] !== t8) {
    t9 = {
      label: t7,
      action: "draft",
      description: t8
    };
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== tRoomListing) {
    t10 = tRoomListing("createInactive");
    $[27] = tRoomListing;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== tRoomListing) {
    t11 = tRoomListing("createInactiveDescription");
    $[29] = tRoomListing;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11) {
    t12 = {
      label: t10,
      action: "inactive",
      description: t11
    };
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12 || $[35] !== t9) {
    t13 = [t9, t12];
    $[34] = t12;
    $[35] = t9;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== isEmailVerified || $[38] !== maxedBanner || $[39] !== session) {
    t14 = maxedBanner ?? (session && !isEmailVerified ? <EmailVerificationBanner /> : undefined);
    $[37] = isEmailVerified;
    $[38] = maxedBanner;
    $[39] = session;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== desktopHeightClassName || $[42] !== form || $[43] !== handleOnSubmit || $[44] !== isSubmitting || $[45] !== onClose || $[46] !== steps || $[47] !== t13 || $[48] !== t14 || $[49] !== t3 || $[50] !== t4 || $[51] !== t5 || $[52] !== t6) {
    t15 = <StepperForm desktopHeightClassName={desktopHeightClassName} handleOnSubmit={handleOnSubmit} form={form} steps={steps} submitButtonText={t3} submitButtonDescription={t4} submitStatusCardLabel={t5} submitStatusSheetTitle={t6} isSubmitting={isSubmitting} onClose={onClose} secondarySubmitActions={t13} warningBanner={t14} data-sentry-element="StepperForm" data-sentry-source-file="NewRoomListing.tsx" />;
    $[41] = desktopHeightClassName;
    $[42] = form;
    $[43] = handleOnSubmit;
    $[44] = isSubmitting;
    $[45] = onClose;
    $[46] = steps;
    $[47] = t13;
    $[48] = t14;
    $[49] = t3;
    $[50] = t4;
    $[51] = t5;
    $[52] = t6;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== adminTargetUserId || $[55] !== t15) {
    t16 = <NewRoomListingContextProvider adminTargetUserId={adminTargetUserId} data-sentry-element="NewRoomListingContextProvider" data-sentry-component="NewRoomListing" data-sentry-source-file="NewRoomListing.tsx">{t15}</NewRoomListingContextProvider>;
    $[54] = adminTargetUserId;
    $[55] = t15;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  return t16;
}